/**
 * Use Unlinked Documents For Audit Hook
 *
 * Returns documents for an audit that are not yet linked to a specific checklist item.
 */

import { useQuery } from "convex/react";
import { api } from "convex/_generated/api";
import type { Id } from "@/packages/types";
import { useWorkspaceId } from "@/hooks";

interface UnlinkedDocument {
  id: string;
  fileName: string;
  fileType: string;
  uploadedAt: number;
}

export function useUnlinkedDocumentsForAudit(
  auditId: Id<"audits"> | null,
  checklistItemId: Id<"checklistItems"> | null,
) {
  const workspaceId = useWorkspaceId();
  return useQuery(
    api.document_queries.getUnlinkedDocumentsForAudit,
    auditId && checklistItemId
      ? { auditId, checklistItemId, workspaceId }
      : "skip",
  ) as UnlinkedDocument[] | undefined;
}
